module.exports = __webpack_public_path__ + "catalog/areas/area/textures/tile1.jpg";